import React from "react";
import { Wheat } from "lucide-react";
import { HEADER } from "@/mock/data";

export default function GovHeader() {
  return (
    <header className="relative mx-3 mt-3 overflow-hidden rounded-2xl shadow-md">
      {/* thin turmeric top accent */}
      <div className="h-1.5 w-full" style={{ background: "linear-gradient(90deg,#E0A106,#5a9e3a,#E0A106)" }} />
      <div
        className="relative flex items-center gap-4 px-5 py-5 text-white sm:px-7"
        style={{ background: "linear-gradient(120deg,#1b5e3f 0%,#2d7a52 100%)" }}
      >
        {/* subtle field-row texture */}
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              "repeating-linear-gradient(115deg, #ffffff 0px, #ffffff 2px, transparent 2px, transparent 22px)",
          }}
        />
        <div className="relative flex h-16 w-16 min-w-[4rem] items-center justify-center rounded-2xl border-2 border-[#E0A106] bg-[#f6f2e6] shadow-sm">
          <Wheat className="h-8 w-8 text-[#1b5e3f]" strokeWidth={2} />
        </div>
        <div className="relative min-w-0">
          <h2 className="text-[13px] font-semibold tracking-wide text-[#f3e4b8] sm:text-[15px]">{HEADER.govt}</h2>
          <h1 className="font-head mt-0.5 text-[19px] font-medium leading-snug sm:text-[24px]">{HEADER.title}</h1>
          <p className="mt-1 text-[11px] text-[#cfe6d2] sm:text-[13px]">{HEADER.sub}</p>
        </div>
      </div>
      {/* Krishna-river wave bottom accent */}
      <div className="h-2 w-full bg-[#E0A106]" />
    </header>
  );
}
